import type { IconName } from '#/components/Icon/IconName';
import type { SocialNetwork } from '#/types/SocialNetwork';

import { getSocialNetworkFromLink } from './getSocialNetworkFromLink';

export const iconNameBySocialNetwork: Record<SocialNetwork, IconName> = {
  x: 'social/x',
  youtube: 'social/youtube',
  facebook: 'social/facebook',
  instagram: 'social/instagram',
  tiktok: 'social/tiktok',
  linkedin: 'social/linkedin',
};

export function getIconNameFromLink(link: string): IconName {
  const socialNetwork = getSocialNetworkFromLink(link);
  return socialNetwork ? iconNameBySocialNetwork[socialNetwork] : 'link';
}
